import { fireOnce, trackStructuredEvent } from 'src/analytics';
import { getCategory } from 'src/interviews/analytics';
import type { MiniInterviewType } from 'src/packages/polaris/types';

export const trackMedicationInputViewed = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
}) => {
  const event = {
    action: 'medication-input-viewed',
    category: getCategory(args.interviewType),
    property: '',
    label: args.interviewToken,
  };
  fireOnce(() => {
    trackStructuredEvent(event);
  }, `${event.action}-${event.category}-${event.property}-${event.label}`);
};

export const trackMedicationInputAnswered = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
  medications: string[];
}) =>
  trackStructuredEvent({
    action: 'medication-input-answered',
    category: getCategory(args.interviewType),
    property: args.medications.join(','),
    label: args.interviewToken,
  });

export const trackMedicationInputSkipped = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
  medications: string[];
}) =>
  trackStructuredEvent({
    action: 'medication-input-skipped',
    category: getCategory(args.interviewType),
    property: 'skipped',
    label: args.interviewToken,
  });

export const trackMedicationInputNotFound = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
  medications: string[];
}) =>
  trackStructuredEvent({
    action: 'medication-input-not-found',
    category: getCategory(args.interviewType),
    property: args.medications.join(','),
    label: args.interviewToken,
  });

export const trackMedicationConfirmationQuestionViewed = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
}) => {
  trackStructuredEvent({
    action: 'medication-confirmation-question-viewed',
    category: getCategory(args.interviewType),
    property: '',
    label: args.interviewToken,
  });
};

export const trackMedicationConfirmationQuestionAnswered = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
}) => {
  trackStructuredEvent({
    action: 'medication-confirmation-question-answered',
    category: getCategory(args.interviewType),
    property: '',
    label: args.interviewToken,
  });
};
